import { apiErrorStatus, apiHttpStatus } from 'app/services/api/apiErrorStatus';

const OFFER_SAVE_ERROR_KEYS: Record<string, string> = {
  INVALID_BADGE_SEGMENT: 'pages.loyalties.alertMessage.badgeCategoryInvalid',
  FREE_OFFER_NEEDS_LIMIT_OR_BADGE: 'pages.loyalties.alertMessage.zeroPointUnrestricted',
  INVALID_STORE_LIST: 'pages.loyalties.alertMessage.invalidStoreList',
  REDEEM_SLOT_ENDED: 'pages.loyalties.alertMessage.redeemSlotEnded',
};

const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === 'object' && value !== null;

// A Pydantic 422 carries a `detail` list rather than an error status; one entry per faulty slot.
const isSlotValidationError = (error: unknown): boolean => {
  if (apiHttpStatus(error) !== 422 || !isRecord(error) || !isRecord(error.response)) return false;
  const detail = isRecord(error.response.data) ? error.response.data.detail : undefined;
  return (
    Array.isArray(detail) &&
    detail.some(entry => isRecord(entry) && Array.isArray(entry.loc) && entry.loc.includes('redeemSlots'))
  );
};

export const offerSaveErrorKey = (error: unknown, fallbackKey: string): string =>
  OFFER_SAVE_ERROR_KEYS[apiErrorStatus(error) ?? ''] ??
  (isSlotValidationError(error) ? 'pages.loyalties.alertMessage.redeemSlotsInvalid' : fallbackKey);
